import React from 'react';
import dayjs from 'dayjs';
import { findDOMNode } from 'react-dom';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import CustomIcon from '../common/CustomIcon';
import PropTypes from 'prop-types';

export class CustomMonthPicker extends React.Component {
  static propTypes = {
    handleDate: PropTypes.func,
    sectionId: PropTypes.string,
    date: PropTypes.object
  };

  state = {
    open: false,
    anchorEl: null,
    anchorOriginVertical: 'bottom',
    anchorOriginHorizontal: 'center',
    transformOriginVertical: 'top',
    transformOriginHorizontal: 'center',
    positionTop: 200,
    positionLeft: 400,
    anchorReference: 'anchorEl',
    month: this.props.date.month,
    year: this.props.date.year
  };

  renderOptionItems() {
    let items = [];
    let { year } = this.state;
    items.push(
      <div className="year-item-container" key={'itemContainer' + items.length}>
        <div
          className="year-selector"
          onClick={() => {
            this.handleClickPreviousYear();
          }}
        >
          <CustomIcon name="left-arrow-circle" size={18} />
        </div>
        <span>{year}</span>
        <div
          className={year < dayjs().year() ? 'year-selector' : 'year-selector-disabled'}
          onClick={() => {
            this.handleClickNextYear();
          }}
        >
          <CustomIcon name="right-arrow-circle" size={18} />
        </div>
      </div>
    );

    for (let i = 0; i < 12; i++) {
      let className = 'month-item';

      if (year === dayjs().year() && i > dayjs().month()) {
        className += ' disabled';
      } else if (this.state.month === i && this.state.year === this.props.date.year) {
        className += ' selected';
      }

      items.push(
        <div
          open={this.state.open}
          onClick={() => {
            this.handleClickMonthItem(i, year);
          }}
          value={i}
          className={className}
          key={i}
        >
          <span>
            {dayjs()
              .month(i)
              .format('MMM')}
          </span>
        </div>
      );
    }

    return <div className="month-selector-container">{items}</div>;
  }

  handleClickButton = () => {
    this.setState({
      open: true,
      anchorEl: findDOMNode(this.button)
    });
  };

  handleClickMonthItem = (month, year) => {
    if (year < dayjs().year() || (year === dayjs().year() && month <= dayjs().month())) {
      this.setState({ month: month });
      this.props.handleDate(this.props.sectionId, { month: month, year: year });
      this.handleRequestClose(month, year);
    }
  };

  handleClickPreviousYear = () => {
    let { year } = this.state;
    this.setState({ year: --year });
  };

  handleClickNextYear = () => {
    let { year } = this.state;
    if (year < dayjs().year()) {
      this.setState({ year: ++year });
    }
  };

  handleRequestClose = (month, year) => {
    if (typeof month === 'number' && year) {
      this.setState({
        open: false,
        year: year,
        month: month
      });
    } else {
      this.setState({
        open: false,
        year: this.props.date.year
      });
    }
  };

  button = null;

  render() {
    const {
      open,
      anchorEl,
      anchorOriginVertical,
      anchorOriginHorizontal,
      transformOriginVertical,
      transformOriginHorizontal,
      positionTop,
      positionLeft,
      anchorReference,
      month
    } = this.state;

    const { year } = this.props.date;

    return (
      <div className="custom-month-picker-container">
        <Button
          ref={node => {
            this.button = node;
          }}
          onClick={this.handleClickButton}
        >
          <span>
            {`${dayjs()
              .month(month)
              .format('MMMM')} ${year} `}
            <CustomIcon name="triangle-arrow-icon" size={16} />
          </span>
        </Button>

        <Popover
          open={open}
          anchorEl={anchorEl}
          anchorReference={anchorReference}
          anchorPosition={{ top: positionTop, left: positionLeft }}
          onClose={this.handleRequestClose}
          anchorOrigin={{
            vertical: anchorOriginVertical,
            horizontal: anchorOriginHorizontal
          }}
          transformOrigin={{
            vertical: transformOriginVertical,
            horizontal: transformOriginHorizontal
          }}
        >
          {this.renderOptionItems()}
        </Popover>
      </div>
    );
  }
}
export default CustomMonthPicker;
